import * as React from "react";
import { stylesheet } from "typestyle";
import { layout } from "../layout.js";
import { classNames } from "../utils.js";
export function NumberStepInput(props) {
    const { className, value, options, onChange, min, max, step = 1 } = props;
    function handleDecrementClick() {
        var _a;
        if (options) {
            const index = options.indexOf(value);
            onChange((_a = options[index - 1]) !== null && _a !== void 0 ? _a : value);
        }
        else {
            const newValue = value - step;
            if (!min || newValue >= min) {
                onChange(newValue);
            }
        }
    }
    function handleIncrementClick() {
        var _a;
        if (options) {
            const index = options.indexOf(value);
            onChange((_a = options[index + 1]) !== null && _a !== void 0 ? _a : value);
        }
        else {
            const newValue = value + step;
            if (!max || newValue <= max) {
                onChange(newValue);
            }
        }
    }
    return (React.createElement("div", { className: classNames(layout.horizontal, styles.container, className) },
        React.createElement("div", { className: classNames(styles.item, styles.stepButton), onClick: handleDecrementClick }, "-"),
        React.createElement("div", { className: classNames(styles.item, styles.value) }, value),
        React.createElement("div", { className: classNames(styles.item, styles.stepButton), onClick: handleIncrementClick }, "+")));
}
const styles = stylesheet({
    item: {
        border: "0.25rem solid var(--color-choice)",
        lineHeight: "3.5rem",
        width: "4rem",
        height: "4rem",
        textAlign: "center",
        marginRight: "0.75rem",
        fontWeight: "bold",
    },
    container: {
        marginRight: "-0.75rem",
    },
    stepButton: {
        backgroundColor: "var(--color-choice)",
        fontSize: "4rem",
        color: "var(--color-background)"
    },
    value: {
        fontSize: "2rem",
    },
});
//# sourceMappingURL=NumberStepInput.js.map